import styled from "@emotion/styled";
export const StaffDetailStyled = styled.div`
  .ant-row {
    display: flex;
  }
  .ant-radio-inner {
    border-color: #000000;
  }
`;
